<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title
        @back="$router.replace({ name: 'home' })"
        :content="$t('orcamento')"
      ></el-page-header>
    </el-card>
    <br />
    <el-row>
      <el-col :span="24">
        <el-button-group>
          <el-button
            @click="changePage()"
            :class="`btn-type ${page === 1 ? 'select' : ''}`"
            type="primary"
            >Importar Arquivo</el-button
          >
        </el-button-group>

        <el-button @click="onSubmit()" class="btn-type success" type="primary"
          >Salvar</el-button
        >
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <el-col :span="12" style="margin-bottom: 20px">
            <el-row :gutter="20">
              <el-col :span="24">
                <label>CLIENTE</label>
                <CustomerList v-model="request.customer" />
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <label>CEP ORIGEM</label>
                <el-input v-model="request.sourceZipcode"></el-input>
              </el-col>
              <el-col :span="4">
                <label>PESO (Kg)</label>
                <el-input v-model="request.weight"></el-input>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-upload
              class="upload"
              drag
              action=""
              :on-change="onChangeFile"
              :auto-upload="false"
              :limit="1"
              v-if="page === 1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Solte o arquivo aqui ou <em>clique para fazer o upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                Somente arquivos .CSV com 200 linhas, e com no máximo 3
                serviços.
              </div>
            </el-upload>
          </el-col>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="page === 1">
      <el-col :span="12">
        <el-card class="box-card">
          <el-table
            :data="servicesData"
            height="250"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column width="80" label="Código" property="code">
            </el-table-column>
            <el-table-column property="name" label="Tipo"> </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <el-table :data="fileSchema" style="width: 100%" height="250" border>
            <el-table-column prop="colum" label="Colunas"> </el-table-column>
            <el-table-column prop="desc" label="Descrição"> </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template> 
<script>
import { ServicesService } from "@/services/customers/services.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import { BudgetService } from "@/services/budget/budget.services.js";

export default {
  name: "LoadObjectsAdd",
  components: {
    CustomerList,
    ServicesList,
  },
  data() {
    return {
      page: 1,
      servicesSelected: [],
      servicesData: [],
      fileSchema: [
        { colum: "CEP", desc: "CEP DO DESTINATÁRIO" },
        { colum: "PESO", desc: "PESO DO OBJETO" },
        { colum: "ALTURA", desc: "ALTURA DO OBJETO" },
        { colum: "LARGURA", desc: "LARGURA DO OBJETO" },
        { colum: "COMPRIMENTO", desc: "COMPRIMENTO DO OBJETO" },
        { colum: "VALOR DECLARADO", desc: "VALOR DECLARADO DO OBJETO" },
      ],
      request: {
        file: {},
        customer: "",
        sourceZipcode: "",
        weight: 0,
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push("/servicos/cargaobjetos").catch(() => {});
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ServicesService.list()
        .then((response) => {
          vm.servicesData = response.records.map((e) => {
            return { id: e.id, code: e.code, name: e.name };
          });
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    changePage() {
      var vm = this;
      if (vm.page === 1) {
        vm.page = 2;
      } else {
        vm.page = 1;
      }
    },
    onChangeFile(file) {
      var vm = this;
      vm.request.file = file;
    },
    handleSelectionChange(event) {
      var vm = this;
      vm.servicesSelected = event;
    },
    onSubmit() {
      var vm = this;
      let formData = new FormData();

      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      formData.append("file", vm.request.file.raw);
      formData.append("sourceZipcode", vm.request.sourceZipcode);
      formData.append("customer", vm.request.customer);
      formData.append(
        "service",
        vm.servicesSelected.map((val) => {
          return val.code;
        })
      );
      formData.append("weight", vm.request.weight);

      BudgetService.upload(formData)
        .then((response) => {
          this.$message({
            type: "success",
            message: "Orçamento adicionado com sucesso!",
          });
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    this.fetchRecords();
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.btn-type {
  background-color: #f6921e !important;
  border: none;
  margin: 2px !important;
  border-bottom: 4px solid #f6921e !important;
}

.success {
  background-color: #67c23a !important;
  border-bottom: 4px solid #67c23a !important;
  float: right;
}

.select {
  border-bottom: 4px solid #000 !important;
}

.upload {
  text-align: right;
}

.upload {
  margin-bottom: 20px;
}

button:focus {
  outline: 0;
}
</style>
